import ko from 'knockout';

export class ViewModel {
  constructor(options) {
    this.isFinalUrl = ko.observable(options.isFinal);

    this.isFinalUrl.Editing = ko.computed({
      read: () => this.isFinalUrl().toString(),
      write: newValue => this.isFinalUrl(newValue === 'true'),
    }, this);
  }
}
